import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@material-ui/core/Box';
import { useQueryCached } from 'components/utils/graphql';
import { EVENTS_LIST } from '../../query/track';
import DropdownButton from '../DropdownButton';
import { DataLoadingContext } from './TrackSeriesChart';

interface PropsIn {
  className?: string;
  athleteSessionId?: string;
  trackId?: string;
  onChange: (events: string[]) => void;
  preset?: string | string[];
  defaultEvents?: string[];
  events: string[];
}

export default function SelectEvents(props: PropsIn) {
  const {
    className, athleteSessionId, trackId, onChange, preset, defaultEvents,
    events,
  } = props;

  const { t } = useTranslation();
  const {isLoading} = useContext(DataLoadingContext);

  const { data } = useQueryCached(EVENTS_LIST(trackId ? 'track' : 'session'), {
    variables: trackId
      ? {
        trackId,
      }
      : {
        id: athleteSessionId,
      },
    skip: !trackId && !athleteSessionId,
    /*
      * Apollo Client bug, using useEffect hook to update data

      onCompleted: () => (data) => {
        console.log('useQuery onCompleted', data)
        if (data.res?.eventsList?.length > 0) {
          console.log(data.res?.eventsList, props.preset.split(','), data.res.eventsList.filter((s) => props.preset.split(',').includes(s)))
          setEvents(data.res.eventsList.filter((s) => props.preset.split(',').includes(s)))
        }
      },
    */
  });

  const handleClick = (e) => {
    if (events.length < 4) {
      if (events.includes(e)) {
        onChange(events.filter((s) => s !== e));
      } else {
        onChange([...events, e]);
      }
    }
  };

  useEffect(() => {
    if (data?.res?.eventsList?.length > 0) {
      const presedFormat = typeof preset === "string" ? preset?.split(',') : preset;
      onChange(data.res.eventsList.filter((s) => (presedFormat || []).includes(s)));
    }
  }, [data]);

  return (
    <Box className={className}>
      <DropdownButton
        label={t('track.widgets.labels.events', 'events')}
        multiple
        multipleSelection
        disabled={isLoading}
        popoverContent={
          data?.res?.eventsList?.map((name) => ({
            value: name,
            label: t(`series.${name}.label`, { defaultValue: name }),
            onClick: () => isLoading ? null : handleClick(name),
          })) || []
        }
        small
        values={events}
        maxValues={3}
      />
    </Box>
  );
}
